var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuperBuiltUpArea = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.54,
  fillRule: "evenodd",
  d: "M8.342 2.554H2.001v6.341h2.195v7.317H2v6.342h6.341v-2.195h7.317v2.195h6.342v-6.342h-2.195V8.895H22V2.554h-6.342v2.195H8.342zm9.512 13.658V8.895H15.66V6.7H8.342v2.195H6.147v7.317h2.195v2.195h7.317v-2.195zm-14.39-8.78V4.017H6.88v3.415zm0 10.244v3.414H6.88v-3.414zM17.123 4.017v3.415h3.414V4.017zm0 17.073v-3.414h3.414v3.414z",
  clipRule: "evenodd"
})));
export default SvgSuperBuiltUpArea;